<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="24"></mat-spinner>
</div>
<ng-content></ng-content>
